const PRODUCT_MANUFACTURE = 'product-manufacture'
const DIGITAL_RETAILER = 'digital-retailer'
const DEALER_USER = 'dealer-user'
const FIELD_ENGINEER = 'field-engineer'
const USER_TXT = '/user'

const pathName = {
  ROOT: '/',
  HOME: '/home',
  DASHBOARD: '/dashboard',
  USER: `${USER_TXT}/:userType`,
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/forgot-password?:uuid',
  ADMIN: `${USER_TXT}/admin`,
  PRODUCT_MANUFACTURE: `${USER_TXT}/${PRODUCT_MANUFACTURE}`,
  DIGITAL_RETAILER: `${USER_TXT}/digital-retailer`,
  DEALER: `${USER_TXT}/dealer`,
  DEALER_USER: `${USER_TXT}/dealer-user`,
  CONTRACTOR: `${USER_TXT}/contractor`,
  FIELD_ENGINEER: `${USER_TXT}/field-engineer`,
  CUSTOMER: `${USER_TXT}/customer`,
  TRANSPORTER: `${USER_TXT}/transporter`,
  DATA_VISUALIZATION: '/data-visualization',
  ADD_USER: `${USER_TXT}/:userType/add`,
  PROFILE: `/profile`,
  CATALOGUE: '/catalogue-management',
  ADD_CATALOGUE: '/catalogue-management/:category/add',
  JOBS: '/jobs',
  ADD_REPAIR: '/jobs/repair/add',
  ADD_INSTALLATION: '/jobs/installation/add',
  EDIT_INSTALLATION: '/jobs/installation/edit/:jobId',
  EDIT_REPAIR: '/jobs/repair/edit/:jobId',
  ADD_JOB: '/jobs/:jobType/add',
  EDIT_JOB: '/jobs/:jobType/edit/:jobId',
}
export default pathName

export {
  USER_TXT,
  PRODUCT_MANUFACTURE,
  DIGITAL_RETAILER,
  DEALER_USER,
  FIELD_ENGINEER,
}
